import styled from 'styled-components';

export const FullHeader = styled.div`
  width: 100%;
  height: 53px;
  position: fixed;
  left: 0px;
  top: 0px;
  background-color: ${(props) => props.theme.palette.background.paper};
  display: flex;
  flex-direction: row;
  z-index: 13;
`;

export const Combined = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 65px);
  box-shadow: ${(props) => props.theme.shadows[8]};
`;

export const Left = styled.div`
  padding-left: 20px;
  min-width: 0px;
  flex: 0 1 auto;
`;

export const Right = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  flex: 0 0.1 auto;
`;

export const Logo = styled.div`
  min-width: 65px;
  height: 100%;
  background-color: ${(props) => props.theme.palette.secondary.main};
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 60%;
  }
`;
